import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalEditProfileComponent } from '../modal-edit-profile/modal-edit-profile.component';
import { ILoggedUser } from '../interfaces/loggedUser';
import { UserService } from '../services/user.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-modal-profile',
  templateUrl: './modal-profile.component.html',
  styleUrls: ['./modal-profile.component.css']
})
export class ModalProfileComponent implements OnInit {
  @Input() userLogged: ILoggedUser;

  oldLocal = localStorage.getItem('localUser')
  itemLocal = JSON.parse(this.oldLocal)
  UserName = this.itemLocal.userName

  constructor(
    private modalService: NgbModal,
    private userService: UserService,
    private modal: NgbActiveModal,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    if (!this.userLogged) this.getUser();
  }

  //Api return Current User
  getUser() {
    this.userService.getUsers(this.UserName).subscribe((data: any) => {
      this.userLogged = data;
      if (this.userLogged.ProfileImg) {
        this.userService.downloadImgProfile(this.userLogged.Id).subscribe(res => {
          this.userLogged.ProfileImgURL = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + res);
        });
      } else this.userLogged.ProfileImgURL = '../../assets/image/Profile.png';
    })
  }

  close() {
    this.modal.close();
  }

  //Method used to open modal of edit profile component.
  openEditProfile() {
    const modalRef = this.modalService.open(ModalEditProfileComponent, { centered: true, size: 'lg' });
    modalRef.componentInstance.userLogged = this.userLogged;
    this.modal.close();
  }

}
